import { render } from "./Waiting.vue?vue&type=template&id=bfdae154&scoped=true"
import script from "./Waiting.vue?vue&type=script&lang=js"
export * from "./Waiting.vue?vue&type=script&lang=js"

import "./Waiting.vue?vue&type=style&index=0&id=bfdae154&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfdae154"]])

export default __exports__